import { Link } from "react-router-dom";
import { Check, Gift, PartyPopper, Disc3 } from "lucide-react";
import { useLanguage } from "../i18n/LanguageContext";
import { IMAGES } from "../i18n/translations";
import { Reveal, SectionHeading, Sparkles, PerBadge } from "../components/ui-bits";

export default function Kinderfeestjes() {
  const { t } = useLanguage();
  const includes = t("kids.items");
  const formulas = t("kids.formulaItems");

  return (
    <main className="pt-32 pb-10 theme-purple">
      <section className="relative max-w-7xl mx-auto px-5" data-testid="kids-section">
        <Sparkles count={10} />
        <SectionHeading eyebrow={<span className="inline-flex items-center gap-2"><PartyPopper size={14} /> Helios</span>} title={t("kids.title")} sub={t("kids.sub")} />

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          <Reveal className="lg:col-span-2">
            <div className="glass glow-card rounded-3xl p-10 text-center sticky top-28" data-testid="kids-price-card">
              <Gift className="mx-auto text-[#F0C971] mb-4" size={40} />
              <span className="font-disco text-6xl gold-text" data-testid="kids-price">{t("kids.price")}</span>
              <div className="mt-4 flex flex-col items-center gap-2">
                <PerBadge>{t("kids.perKid")}</PerBadge>
                <span className="text-xs font-bold uppercase tracking-widest text-[#E2F1FF] bg-[#00F0FF]/10 border border-[#00F0FF]/30 px-3 py-1 rounded-full">
                  {t("kids.minKids")}
                </span>
              </div>
              <Link to="/reserveer" data-testid="kids-book-cta" className="btn-neon mt-8 inline-block font-display text-lg tracking-[0.25em] uppercase px-10 py-4 rounded-full">
                {t("kids.cta")}
              </Link>
              <p className="mt-6 text-xs text-[#9db8d6]">{t("kids.discoNote")}</p>
            </div>
          </Reveal>

          <div className="lg:col-span-3 space-y-8">
            <Reveal delay={0.1}>
              <div className="glass rounded-3xl p-8">
                <h3 className="font-display text-2xl uppercase tracking-widest neon">{t("kids.included")}</h3>
                <ul className="mt-5 space-y-3">
                  {includes.map((item, i) => (
                    <li key={i} data-testid={`kids-include-${i}`} className="flex gap-3 text-[#E2F1FF]">
                      <Check size={17} className="text-[#00F0FF] shrink-0 mt-0.5" /> {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Reveal>
            <Reveal delay={0.18}>
              <div className="glass rounded-3xl p-8">
                <h3 className="font-display text-2xl uppercase tracking-widest neon">{t("kids.formulas")}</h3>
                <div className="mt-5 grid sm:grid-cols-2 gap-3">
                  {formulas.map((f, i) => (
                    <div key={i} data-testid={`kids-formula-${i}`} className="rounded-xl border border-[#F0C971]/30 bg-[#F0C971]/5 px-4 py-3 text-sm text-[#E2F1FF]">
                      {f}
                    </div>
                  ))}
                </div>
                <div className="mt-6 flex items-center justify-between rounded-xl bg-[#00F0FF]/5 border border-[#00F0FF]/25 px-5 py-4" data-testid="kids-extra-game">
                  <span className="text-sm text-[#E2F1FF] flex items-center gap-2"><Disc3 size={16} className="text-[#00F0FF]" /> {t("kids.extra")}</span>
                  <span className="font-disco text-2xl neon">{t("kids.extraPrice")}</span>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="mt-14 relative rounded-3xl overflow-hidden h-72 group">
            <img src={IMAGES.kidsParty} alt="Kinderfeestje" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            <div className="absolute inset-0 bg-gradient-to-t from-[#05070B] via-transparent to-transparent" />
          </div>
        </Reveal>
      </section>
    </main>
  );
}
